import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_BIZ_USER, IS_CORP_USER, IS_MOBILE_BROWSER, IS_REGULAR_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import type { Product } from 'reactApp/types/Billing';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface BusinessTariffs {
    month: string[];
    year: string[];
}

export const businessTariffsPromoQuotaFeature: 'a' | 'b' | false = getFeature('ab-business-tariffs-promo-quota');

const businessTariffs: BusinessTariffs = getFeature('ab-business-tariffs-promo-quota-tariffs') || {
    month: [
        'W256GB_1m_business_discount',
        'W512GB_1m_business_discount',
        'W1TB_1m_business_discount',
        'W2TB_1m_business_discount',
        'W4TB_1m_business_discount',
    ],
    year: [
        'W256GB_1y_business_discount',
        'W512GB_1y_business_discount',
        'W1TB_1y_business_discount',
        'W2TB_1y_business_discount',
        'W4TB_1y_business_discount',
    ],
};

const queryParams = getQueryParams();
const forcedByQuery = queryParams?.initTab === ETabsName.for_work;

export const businessTariffsPromoQuota = {
    enabled:
        (forcedByQuery || businessTariffsPromoQuotaFeature === 'b') &&
        !IS_WEBVIEW &&
        !IS_MOBILE_BROWSER &&
        !IS_BIZ_USER &&
        (IS_REGULAR_USER || ANONYM_USER) &&
        !IS_CORP_USER,
    tariffs: businessTariffs,
    showCancelLetterFeature: isFeature('ab-business-tariffs-promo-quota-cancel-letter-feature'),
} as const;

const isBusinessProduct = (product: Product) => {
    return businessTariffs?.month?.includes(product.id) || businessTariffs?.year?.includes(product.id);
};

registerExperiment(
    'for-work-ms',
    forcedByQuery ? 'q' : businessTariffsPromoQuotaFeature,
    [
        AnalyticEventNames.TARIFFS_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
        AnalyticEventNames.TARIFF_CLICK,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
    ],
    {
        mapEventNames: {
            TARIFFS_SHOWN: 'tariffs',
            TARIFF_BUY: 'buy',
            TARIFF_CLICK: 'click',
            FAST_CHECKOUT_SHOWN: 'checkout',
        },
        sendXrayArgs: {
            TARIFFS_SHOWN: ({ tariffs_line }) => ({ cancel: tariffs_line !== 'for_work' }),
            TARIFF_BUY: ({ product }) => ({ cancel: !isBusinessProduct(product) }),
            TARIFF_CLICK: ({ product }) => ({ cancel: !isBusinessProduct(product) }),
            FAST_CHECKOUT_SHOWN: ({ productId }) => ({ cancel: !isBusinessProduct({ id: productId } as Product) }),
        },
    }
);
